/**
 * This function use for formating `LearnId` value to format xxx-xxx-xxxx.
 */
export const getLearnIdFormat = (learnId: string) => {
  const learnIdRegex = /^(\d{3})(\d{3})(\d{4})$/g;
  // $1, $2, and $3 are a group of regex patterns in line 9.
  const newLearnId = learnId.replace(learnIdRegex, '$1-$2-$3');
  return newLearnId;
};
